export default {
  BAndRText: "Bücher & Rezensionen",
  Srchbook: "Nach Buch suchen",
  offlisugg: "Ofellios Vorschläge ",
  recentlyRated: "Kürzlich bewertet",



  // ReviewPage
  rewbtn1: "Zu lesen",
  rewbtn2: "Schreibe eine Bewertung",
  rewbtn3: "Verwenden für Book Duo",
  rateBook: "Bewerte dieses Buch",
  buyon: "Kaufen auf",
  Read: "Gelesen",
  reviewtext: "Bewertung",
  ratingtext: "Deine Bewertung",
  readon: "Gelesen auf",
  book: "Buch",
  ebook: "E-book",
  audiobook: "Audiobook",
  revTitle: "Titel",
  submitbtn: "Senden",


  // Book Duo Page
  yourbd: "Dein Book Duo",
  serchbook: "Buch suchen",
  DidText: "Dein Buch nicht gefunden? Gib die Details ein!",
  city: "Stadt",
  type: "Art",
  lookigfr: "Ich suche",
  male: "Männlich",
  female: "Weiblich",
  idk: "Gleichgültig",
  agerg: "Altersgruppe",
  language: "Sprache",
  detil: "Details ",
  optnal: "Optional",
  lookiginsp: "Einige Vorschläge",
  suggbokduo: "Vorgeschlagene Bücher für ein Book Duo",
  seemoresugg: "Weitere Vorschläge ansehen",
  bokcvr: "Buchcover ",
  title: "Titel",
  writer: "Autor ",
  genre: "Genre",
  upload: "Lade hoch ",
  add: "Hinzufügen ",
  online: "Online"
  , onlink: "Füge den Link zum Videoanruf hinzu (Teams, Zoom, Google Meet usw.)",
  noBookSelected: "Kein Buch ausgewählt",
  loading: "Lädt...",
  noResultsFound: "Keine Ergebnisse gefunden",
  meetingLink: "Meeting-Link",
  noLimit: "Kein Limit",
  languageTooltip: "Dies ist die Sprache, die die Teilnehmer während des Book Duo sprechen werden.",
  languageTooltipBookClub: "Dies ist die Sprache, die die Teilnehmer während des Book Club sprechen werden.",
  updating: "Aktualisiere...",
  publishing: "Veröffentliche...",
  update: "Aktualisieren",
  noBooksFound: "Keine Bücher unter diesem Vorschlag für ein 1:1 gefunden.",
  wellDone: "Gut gemacht!",
  bookDuoLive: "Dein Book Duo ist jetzt live.",
  willInformInterest: "Wir werden dich informieren, wenn jemand Interesse zeigt!",
  seeOn: "Siehe auf",
  map: "Karte",


  // Book Club Page
  when: "Wann",
  time: "Uhrzeit ",
  age: "Alter",
  publsbtn: "Veröffentlichen ",
  day: "Tag",
  month: "Monat",
  year: "Jahr",
  hour: "Stunde",
  min: "Minute",
  max: "Max",
  selectTime: "Zeit auswählen",
  selectLanguage: "Sprache auswählen",
  selectType: "Typ auswählen",
  inPerson: "Persönlich",
  attendees: "Teilnehmer",
  eventDetails: "Veranstaltungsdetails",

  // Silent Reading Page
  where: "Wo",
  venue: "Veranstaltungsort",
  address: "Adresse",



  // BookAnd Review page Event
  welc: "Willkommen",
  memb: "Mitglied",
  exploreText: "Entdecke und nimm an verfügbaren Veranstaltungen in deiner Stadt oder online teil und erstelle deine eigene.",
  sbybooks: "Nach Titeln suchen",
  sortby: "Sortieren nach",
  cbduo: "Erstelle Book Duo",
  smoreevent: "Weitere Veranstaltungen anzeigen",
  dowant: "Möchtest du dein eigenes Event erstellen?",
  ledAmbsdr: "Die Book Clubs und das Silent Reading werden von Ambassadors geleitet.",
  bAnAmbsdor: "Werde ein Ambassador  ",
  leadText: "Eines leiten oder erkunden und teilnehmen",
  evtnear: "  Veranstaltungen in deiner Nähe.",
  BookDuoFirstText: `Bist du auf der Suche nach einer authentischen Verbindung? Ein Book Duo ist perfekt für dich!`,
  BookDuoSecondText: ` Wähle einfach ein Buch, wähle das Genre und das Altersbereich des Partners, mit dem du dich verbinden möchtest, und schon bist du bereit! Wenn jemand Interesse zeigt, startest du einen Chat und organisierst die Details deines One-to-One-Events`,

  BookClubFirstText: `Entdecke Buchclubs vor Ort in deiner Nähe oder online, veranstaltet in gemütlichen Umgebungen wie Cafés, Bars oder einladenden Veranstaltungsorten oder per Videokonferenz.`,
  BookClubSecondText: `Jeder Ofellio Book Club heißt bis zu 8 Teilnehmer willkommen, nach Altersgruppen sortiert, um eine angenehmere und ansprechendere Erfahrung zu bieten. Die Diskussion wird von einem Ofellio-Ambassador moderiert, der eine lebendige und inklusive Atmosphäre gewährleistet`,

  BookSilentFirstText: `In einer entspannten und komfortablen Umgebung bieten Silent Readings bis zu 10 Leserinnen und Lesern eine ruhige Auszeit.`,
  BookSilentSecondText: `Geleitet von einem Ofellio-Ambassador lädt jede Sitzung dazu ein, dein eigenes Buch mitzubringen, in Stille zu lesen und, wenn du möchtest, dich in einer lockeren Atmosphäre mit anderen auszutauschen.`,

  DuoBtnText: `Erstelle Book Duo`,
  ClubBtnText: `Erstelle Book Club`,
  SilentBtnText: `Erstelle Silent Reading`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Book Club",
  bookSilentTitle: "Silent Reading",



  // BOOK_CLUB DUO SILENTREADING
  yownbook: "Dein Buch",
  resetFilters: "Filter zurücksetzen",
  resetAll: "Alle zurücksetzen",
  applyFilters: "Filter anwenden",
  filters: "Filter",
  full: "VOLL",
  booked: "Gebucht",
  open: "Geöffnet",
  buyon: "Kaufen auf",
  gender: "Geschlecht",
  locatedin: "Standort",
  aboutbook: `Handlung`,
  readmore: `Lies mehr`,
  readless: `Lies weniger `
  , details: "Details",
  totalspot: "Gesamte Plätze",
  spotleft: "Verbleibende Plätze",
  join: "Nimm teil",
  share: "Teile",
  cregistration: "Vervollständige die Registrierung",
  registrationmsg: "Deine E-Mail-Adresse wird mit dem Ambassador geteilt",
  welldone: "Gut gemacht!",
  attending: "Du nimmst an ... Teil ",
  attendmsg: "Du kannst dieses Event jetzt in deinem Ofellio-Dashboard sehen und mit deinem Ambassador chatten"
  , thankyou: "Danke!",
  thankmsg: "Der Organisator ist nun über dein Interesse informiert und kann dir eine Nachricht senden, um die Details dieses Book Duo zu arrangieren"
  ,

  // CHAT PAGE
  msgtext: "Nachrichten ",
  vprofile: "Profil anzeigen",
  mute: "Stummschalten",
  block: "Blockieren",
  unblock: "Entsperren"
  , report: "Melden",
  cancelR: "Abbrechen",

  // Setting Page
  pprofile: "Persönliches Profil",
  accnotifi: "Benachrichtigungen",
  uploadp: "Foto hochladen",
  name: "Name",
  surname: "Nachname",
  dob: "Geburtsdatum",
  aboutme: "Über mich",
  country: "Land",
  favgenre: "Lieblingsgenres",
  asmedia: "Füge deine sozialen Konten hinzu",
  savechgbtn: "Änderungen speichern",


  cypass: "Ändere dein Passwort",
  cypasstext: "Wenn du dein Passwort änderst, wirst du automatisch aus deinen anderen Sitzungen abgemeldet",
  cpass: "Passwort ändern",
  cyemail: "E-Mail ändern",
  cyemailtext: "Wenn du Passwort änderst, wirst du automatisch aus anderen Sitzungen abgemeldet",
  cemail: "E-Mail ändern",
  notifi: "Benachrichtigung ",
  emailmeab: "Benachrichtige mich über",
  lastesttext: "Neueste Trending-Bücher",
  upcomtext: "Neue Bücher des kommenden Monats",
  baevent: "Bücher, Autoren und Veranstaltungen, die mir gefallen würden",
  newoff: "Neue Ofellio-Funktionen",
  leadin: "Ich leite",

  curnpass: "Aktuelles Passwort",
  newpass: "Neues Passwort",
  cnewpass: "Bestätige neues Passwort",
  curnemail: "Aktuelle E-Mail",
  newemail: "Neue E-Mail",
  cnewemail: "Neue E-Mail bestätigen",
  delyacc: "Konto löschen ",
  sorrytext: "Es tut uns sehr leid, dass du uns verlassen willst!",
  suretext: "Bist du sicher, dass du das tun möchtest? ",
  decitext: "Wenn du Ofellio erneut nutzen möchtest, musst du ein neues Konto erstellen.",
  pass: "Passwort",

  // meun
  jan: "Januar",
  feb: "Februar",
  mar: "März",
  apr: "April",
  may: "Mai",
  jun: "Juni",
  jul: "Juli",
  aug: "August",
  sep: "September",
  oct: "Oktober",
  nov: "November",
  dec: "Dezember",
  // Month abbreviations
  monthAbbrJan: "Jan",
  monthAbbrFeb: "Feb",
  monthAbbrMar: "Mär",
  monthAbbrApr: "Apr",
  monthAbbrMay: "Mai",
  monthAbbrJun: "Jun",
  monthAbbrJul: "Jul",
  monthAbbrAug: "Aug",
  monthAbbrSep: "Sep",
  monthAbbrOct: "Okt",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Dez",
  cri: "Krimi  ",
  fic: "Fiktion   ",
  grpnvl: "Graphic Novels & Manga ",
  yng: "Junge Erwachsene & LGBTQ+",
  nonfic: "Sachbücher  ",
  scifan: "Science-Fiction & Fantasy  ",
  others: "Andere",
  morerec: "Neueste",
  lessrec: "Älteste ",

  // HeaderProfil
  setg: "Einstellungen ",
  logout: "Abmelden",


  // dashbords pages
  editprf: "Profil bearbeiten",
  cbduo: "Erstelle Book Duo",
  joining: "Ich bin dabei",
  bandrew: "Bücher & Rezensionen",
  upcomclub: "Kommend Book Clubs",
  upcomduo: "Kommend Book Duo",
  upcomsil: "Kommend Silenet Readings",
  allpst: "Vergangene Veranstaltungen",
  edit: "Bearbeiten",
  canc: "RSVP stornieren",
  going: "Ich gehe",
  ngoing: "Ich nehme nicht teil",
  cancel: "Abbrechen",

  level: "Stufe ",
  cbclub: "Erstelle Book Club",
  cbsil: "Erstelle Silent Reading",
  loyprog: "Treueprogramm",
  mang: "Verwalten",
  attlist: "Teilnehmerliste",
  event: "Event bearbeiten",
  chatgroup: "Mit der Gruppe chatten",
  chatambas: "Mit Ambassador chatten",
  bookshelv: "Bücherregale von",
  reviews: "Bewertungen",

  // Leading Page
  ambassador: "Ambassador",
  member: "Mitglied",
  level1: "Stufe 1",
  level2: "Stufe 2",
  level3: "Stufe 3",
  level4: "Stufe 4",
  toLevel: "zu",
  highestLevel: "🎉 Du hast das höchste Level erreicht!",
  editProfile: "Profil bearbeiten",
  createBookClub: "Erstelle Book Club",
  createSilentReading: "Erstelle Silent Reading",
  createBookDuo: "Erstelle Book Duo",
  createEvent: "+ Event erstellen",
  attendeesList: "Teilnehmerliste",
  wantToRead: "Zu lesen",
  read: "Gelesen",
  remove: "Entfernen",
  tbd: "TBD",
  full: "VOLL",
  yourOwnBook: "Dein Buch",
  ageLabel: "Alter:",
  manage: "Verwalten",
  cancelRSVP: "RSVP stornieren",
  imLeading: "Ich leite",
  imJoining: "Ich nehme teil",
  booksAndReviews: "Bücher & Rezensionen",
  loyaltyProgram: "Treueprogramm",
  upcomingBookClubs: "Kommende Book Clubs",
  upcomingSilentReadings: "Kommende Silent Readings",
  upcomingBookDuos: "Kommende Book Duos",
  noEventsToShow: "Keine Veranstaltungen anzuzeigen.",
  wantToReadLower: "Zu lesen",
  readLower: "Gelesen",
  reviewsLower: "Bewertungen",
  noRatedBooks: "Du hast noch keine Bücher bewertet.",
  giftsDiscounts: "Geschenke und Rabatte beim Lesen",
  loyaltyDescription: "Je mehr du liest, desto mehr gewinnst du! Genieße Rabatte und Vorteile, während du aufsteigst.",
  starterReader: "Anfänger-Leser",
  starterReaderDesc: "Beginne deine Reise als Ofellio-Ambassador und beginne, deine ersten Leseerfahrungen zu leiten.",
  starterReaderReward: "Frühe Anerkennung und Zugang zu zukünftigen Ambassador-Vorteilen.",
  communityBuilder: "Gemeinschaftsbildner",
  communityBuilderDesc: "Verbinde weiterhin Leser und erstelle ansprechende Buchevents in deiner Gemeinschaft.",
  communityBuilderReward: "Prioritätszugang zu neuen Funktionen und exklusiven Updates.",
  proHost: "Pro-Host",
  proHostDesc: "Du gestaltest bedeutsame Leseerlebnisse und inspirierst andere durch deine Events.",
  proHostReward: "Einladungen zu bevorstehenden Ofellio-Initiativen und besondere Überraschungen.",
  legend: "Legende",
  legendDesc: "Inspiriere weiterhin Leser weltweit — deine Führung prägt die Ofellio-Gemeinschaft.",
  legendReward: "Schalte exklusive Anerkennung und sich entwickelnde Vorteile frei.",
  attendees: "Teilnehmer",
  noAttendeesYet: "Noch keine Teilnehmer.",
  // Modal translations for add book manually
  booksCover: "Buchcover",
  writerLabel: "Autor",
  genreLabel: "Genre",
  aboutTheBookLabel: "Über das Buch",
  addButton: "Hinzufügen",
  chatWithGroup: "Mit der Gruppe chatten",
  cancelEvent: "Event stornieren",
  cancelRSVPConfirm: "Bist du sicher, dass du dein RSVP stornieren möchtest?",
  cancelEventConfirm: "Bist du sicher, dass du dieses Event stornieren möchtest?",
  cancelRSVPEmail: "Eine Stornierungs-E-Mail wird an den Ambassador gesendet.",
  cancelEventEmail: "Eine Stornierungs-E-Mail wird an die aktuellen Teilnehmer gesendet.",

  // How It Works Section
  howOfellioWorks: "Wie Ofellio funktioniert",
  howItWorksDesc: "Entdecke neue Wege, dich durch Bücher zu verbinden — ob im Einzelgespräch, in der Gruppe oder in friedlichen Silent Reading-Sitzungen.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "Auf der Suche nach einer persönlichen Verbindung? Wähle ein Buch, wähle das Alter und Geschlecht des Partners und beginne eine one-to-one literarische Reise.",
  bookClubTitle: "Book Club",
  bookClubDesc: "Nimm an einladenden Book Clubs vor Ort oder online teil, die in gemütlichen Umgebungen veranstaltet werden. Jede Gruppe wird von einem Ambassador moderiert, um eine lebendige und inklusive Erfahrung zu gewährleisten.",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "Genieße friedliche Silent Reading-Sitzungen. Bring dein eigenes Buch mit, entspanne dich und teile die ruhige Freude am gemeinsamen Lesen.",
  exploreThe: "Entdecke die",
  existingEvents: "bestehenden Veranstaltungen",
  or: "oder",
  createYourOwn: "erstelle deine eigene",
  joinOfellio: "Ofellio beitreten",
  signUp: "Registrieren",
  chooseYourCountry: "Wählen Sie Ihr Land",
  joined: "teilgenommen",
  joinedCapitalized: "Teilgenommen",
  shareThisEvent: "Dieses Event teilen",
  linkVisibleAttendees: "Link nur für Teilnehmende sichtbar",
  recentReviews: "Aktuelle Bewertungen",
  noReviewsAvailable: "Keine Bewertungen verfügbar",
  writeAReview: "Eine Bewertung schreiben",
  yourRating: "Ihre Bewertung",
  update: "Aktualisieren",
  aboutTheBook: "Über das Buch",
  makeAChoiceForThisBook: "Treffen Sie eine Wahl für dieses Buch",
  howDidYouReadIt: "Wie haben Sie es gelesen?",
  noRating: "Keine Bewertung",
  reviewPublished: "Bewertung veröffentlicht",
  useForBookDuo: "Für Book Duo verwenden",
  yourReview: "Ihre Bewertung",
  addAShortTitle: "Einen kurzen Titel hinzufügen",
  shareYourThoughts: "Teilen Sie Ihre Gedanken zu diesem Buch...",
  send: "Senden",
  bookclubLive: "Gut gemacht! Dein Bookclub ist jetzt online und Teilnehmer können beitreten.",
  silentReadingLive: "Gut gemacht! Dein Stilles Lesen ist jetzt online und Teilnehmer können beitreten.",
  dashboard: "Dashboard",

  // Day abbreviations
  dayMon: "Mo",
  dayTue: "Di",
  dayWed: "Mi",
  dayThu: "Do",
  dayFri: "Fr",
  daySat: "Sa",
  daySun: "So",
  
  // Additional translations
  ambassadorLabel: "Ambassador:",
  createdBy: "Erstellt von:",
  youAreAttendingThis: "Du nimmst an diesem",
  youCanNowSeeThisEvent: "Du kannst dieses Event jetzt in deinem Ofellio-Dashboard sehen und chatten",
  withYourAmbassador: "mit deinem Ambassador",
  chatWithAmbassador: "Mit Ambassador chatten",
  yourRequestHasBeenSent: "Deine Anfrage wurde an den Ambassador gesendet",
  sentYouAMessage: "hat dir eine Nachricht gesendet!",
  justJoinedYour: "ist deinem",
  bookClubsAndSilentReadings: "Book Clubs und Silent Readings werden von Ambassadors geleitet.",
  becomeAnAmbassador: "Werde ein Ambassador",
  toLeadOneOrExplore: "um eines zu leiten oder zu erkunden und beizutreten",
  eventsAvailable: "verfügbare Veranstaltungen.",
};
